
<div class="mainBG">

    <div class="white container-fluid mainContent">
        <div class="lock-screen">
            <div class="animate fadeIn text-center">
                <!-- added 'row' class -->
                <div class="row">
                    <div class="col-md-7 px-0">
                        <!-- replaced 'img-responsive' class with 'img-fluid' -->
                        <img src="assets/images/Left_Img.png" height="550px" class="img-fluid" style="height: 550px;">
                    </div>

                    <div class="col-md-5 p-0 bottom-align1 bg-white roundedRight">
                        <div class="col-md-12">
                            <!-- added 'row' class -->
                            <div class="row mb-10 justify-content-lg-center">
                                <!-- *ngIf="loginservice && loginservice.hideGebbsLogo==false" -->

                                <span class="col-md-6">
                                    <div class="mt-5">
                                        <!-- replaced 'img-responsive' class with 'img-fluid' -->
                                        <img src="assets/images/iAR.png" width="98px" height="66px">
                                    </div>
                                </span>
                            </div>
                            <!-- <div class="col-md-12 text-center version-text"> Version: {{version}}</div>
                            <div class="col-md-12 text-center version-text"> Released Version: {{ReleasedVersion}}</div> -->
                             <div class="col-md-12 text-center version-text" style="color: #3579b1; font-size: 16px; top: 12px;"> Forgot Password</div>
                        </div>


                        <form *ngIf="SwitchToReset" [formGroup]="ResetForm" (ngSubmit)="ResetPassword()" style="top:25px; position: relative;">
                          <div class="col-md-12 ">
                             <div class="form-item">
                                <input type="password" required  [maxlength]="maxLength" formControlName="New_Password"
                                name="password" id="newpass" [minlength]="minLength"
                                 [ngClass]="{'input-error': ResetForm.get('New_Password').hasError('required') && DisplayError}">
                                <label for="newpass">New Password</label>
                               <div class="error" style="left: 80px;" *ngIf="ResetForm.controls['New_Password'].hasError('pattern') && ResetForm.controls['New_Password'].dirty">
                                <span style="    width: 250px;    position: relative;    display: flex;    margin-bottom: 15px;">     New Password should be of {{minLength}} to {{maxLength}} characters and must contain 1 capital,1 small,1 special and 1 digit character
                                    </span>
                                </div>
                            </div>


                            <!-- <div class="form-group">
                                <label for="newpass" class="label-std control-label p-0 b-600">New Password</label>
                                <input minlength="8" maxlength="20" type="password" autocomplete="off" class="form-control" formControlName="New_Password" id="newpass" placeholder="New Password" value="">
                                 <div class="error" *ngIf="ResetForm.controls['New_Password'].hasError('pattern') && ResetForm.controls['New_Password'].dirty">
                                    New Password should be of 8 to 20 characters and must contain 1 capital,1 small,1 special and 1 digit character
                                </div>
                            </div> -->
                        </div>
                        <div class="col-md-12 " >

                             <div class="form-item">
                                <!-- <input type="password" required maxlength="20" formControlName="confirmnewpass"   name="confirmpass" id="confirmnewpass" minlength="8"
                                 [ngClass]="{'input-error': ResetForm.get('confirmnewpass').hasError('required') && DisplayError}"> -->

                                 <input type="password" class="form-control" id="confirmnewpass" formControlName="confirmnewpass"  value="" required>
                                <label for="confirmnewpass">Confirm New Password</label>
                                <div class="error" *ngIf="ResetForm.get('confirmnewpass').hasError('required') && ResetForm.controls['confirmnewpass'].dirty && DisplayError">
                                    <span style="width: 150px;    position: relative;    display: flex;    margin-bottom: 15px;"> Please Confirm New Password
                                    </span>
                                </div>
                                <div class="error" *ngIf="ResetForm.get('confirmnewpass').hasError('notMatch') && ResetForm.controls['confirmnewpass'].dirty">
                                 <span style="    width: 250px;left: 65px;    position: relative;    display: flex;    margin-bottom: 15px;"> New password and confirm password should be same
                                    </span>
                                </div>

                            </div>
                        </div>
                             <div class="col-md-10" *ngIf="ResetForm.controls.captchaData as captcha">
                                <div class="form-group" style="margin-bottom:0">
                                    <div class="captchaContainer">
                                    <img [src]="showCaptcha" alt="captcha" class="captcha">

                                        <div class="controls" style="margin-left: 5px;">
                                            <div class="" style="width: 155px; margin-right: -10px;">
                                                <input class="form-control valid" formControlName="captchaData" type="text" placeholder="Type above text">
                                            </div>
                                            <button title="Refresh Captcha Code" type="button" class="btn btn-primary" style="height: 28px; padding-top: 1px;" (click)="callCaptcha()">
                                                <i [ngClass]="{'rotate': isCaptcha == true}" class="fa fa-refresh"></i>
                                            </button>
                                                <span class="errorSection" *ngIf="captcha.touched==true || DisplayError"
                                                style="position: absolute; left: 125px;  top: 85%;">
                                                    <span class="error"
                                                        *ngIf="ResetForm.get('captchaData').hasError('required') && DisplayError">
                                                        Captcha is required.
                                                    </span>
                                                    <div class="error"
                                                        *ngIf="captcha.errors && captcha.errors.invalidCaptcha">
                                                        Please type valid Captcha
                                                    </div>
                                                </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <div class="col-md-12 text-center" style="right: 20px; position: relative;">
                            <button type="submit" [disabled]="DisableSubmit" class="btn blue square-btn blue-hover btn-txt btn-default">Submit</button>
                        </div>
                    </form>



                        <div class="col-md-12 text-center" style="position: absolute;bottom: 5rem;left: 40vh;">
                            <span>Released Version: {{ReleasedVersion}}</span><br>
                            <span>Copyright &copy; {{CurrentYear}} GeBBS Healthcare Solutions |
                                <span><a style="cursor: pointer;" class="text-primary focus" (click)="ShowCopyright()">Disclaimer</a></span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center text-white py-2">
                    <p><b>Security Notice:</b> You are using a secure web connection. Your password will be encrypted in transit to our web server, but will remain on your
                        browser until you exit it.
                    </p>
                </div>

            </div>
        </div>


    </div>
</div>




  <div class="modal fade bd-example-modal-lg" id="myModal" role="dialog" [ngClass]="[showCopyright == true ? 'showmodal' : 'hidemodal']">
    <div class="modal-dialog"style="max-width: 750px!important;">
                <div class="modal-content modalContent" style="margin-top: 20rem;">
            <div class=" modalHeader" style="text-align: center;">
                <button type="button" class="close"style="font-size: 24px;" data-dismiss="modal"(click)="closeCopyright()">&times;</button>
                <h4 style="font-size: 19px;
                font-weight: 700;" class="modal-title"><i class="fa fa-warning"></i> UNAUTHORIZED ACCESS TO THIS SERVICE IS PROHIBITED.</h4>
            </div>
            <div class="modal-body">


                <div class="disclaimer-text" style="font-size: 11px; line-height: 16px; text-align: justify;">
                    <p class="para" style="text-align: center;">
                        <span style="font-weight: 700;">PLEASE READ THE TERMS AND CONDITIONS :</span>
                        <br> <br>
                        <span style="text-align: center;">iAR is confidential and proprietary, and is for authorized users only. All authorized users are subject to contractual use restrictions and nondisclosure requirements that prevent giving access to third parties. Unauthorized users are subject to prosecution, lawsuits, and penalties under state and federal law. All system activities are monitored, recorded and reviewed by system personnel. Anyone using this system expressly consents to such monitoring and is hereby warned that if such monitoring reveals possible evidence of criminal activity by the user, the same shall be reported to law enforcement Agency. Provider reserves the right, at its sole discretion, to change, modify the software or program at any time without notice. Any rights not expressly granted herein are reserved.
                        </span><br> <br> <br>
                       <span style="font-weight: 700;">Contact: Infosec Team - infosec&#64;gebbs.com</span>

                    </p>
                </div>
            </div>
            <div class="modal-footer"style="display: inline;">
                <button type="button" class="btn btn-default blue square-btn blue-hover btn-txt"(click)="closeCopyright()" style="margin-left:45%;font-size: 1.3rem;" data-dismiss="modal">Close
                    </button>
            </div>
        </div>

    </div>
</div>
